import React from 'react'

const MannerExecution = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>The manner of execution of subsidy programme</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg "
        style={{ textAlign: "justify" }}
      >
      <p>The subsidy allowed by Govt. on distribution of certified seeds under NFSM, MMA, RKVY and ISOPOM schemes is passed on to the farmers at the time of sale of seeds.</p>
    </div>
    </div>
  )
}

export default MannerExecution
